<template>
  <Section>
    <template #header>
      <div class="mr-auto">
        <strong class="black--text">Address + Coverage</strong>

        <div class="grey--text text--darken-1">
          {{ pro.address.street }}, {{ pro.address.city }},
          {{ pro.address.state }}, {{ pro.address.zipcode }} - {{ pro.coverage_radius}}mi
        </div>
      </div>
      <AddressDialog :pro="pro" />
    </template>

    <l-map v-if="pro.address.place_id" style="height: 220px" :zoom="zoom" :center="center">
      <l-tile-layer :url="url" :attribution="attribution" />
      <l-marker :lat-lng="center" />
      <l-circle :lat-lng="center" :radius="radius" color="green" />
    </l-map>
    <div style="height: 220px" class="grey lighter-2 text-center pa-4 black--text" v-else>
      Please edit this to confirm your address...
    </div>
  </Section>
</template>

<script>
  import { Section } from '@/components/pages'
  import { latLng } from 'leaflet'
  import { LCircle, LMarker, LMap, LTileLayer } from 'vue2-leaflet'
  import AddressDialog from '../dialogs/AddressDialog'

  export default {
    components: { Section, LCircle, LMarker, LMap, LTileLayer, AddressDialog },

    props: ['pro'],

    data() {
      return {
        zoom: 8,
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      }
    },

    computed: {
      center() {
        return latLng(this.pro.address.latitude, this.pro.address.longitude)
      },

      radius() { 
        // in meters
        return this.pro.coverage_radius * 1609.34
      },
    },
  }
</script>
